import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './SupportPage.css';

const SupportPage = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      id: 1,
      question: 'How do I change or cancel a booking?',
      answer: 'You can modify or cancel your booking through your dashboard. Go to "My Trips" and select the booking you want to change. For cancellations, refunds are processed within 5-7 business days to your original payment method. Cancellation fees may apply based on your fare type and timing.'
    },
    {
      id: 2,
      question: 'How long do refunds take in Nigeria?',
      answer: 'Refunds to Nigerian bank accounts typically take 5-7 business days. For card payments, refunds may take 7-14 business days depending on your bank. You\'ll receive an email confirmation once the refund is processed. If you don\'t see the refund after 14 days, please contact our support team.'
    },
    {
      id: 3,
      question: 'Why is my bank declining my card?',
      answer: 'Common reasons include insufficient funds, daily transaction limits, or your bank\'s security settings blocking international transactions. Try using a different card, contact your bank to authorize the transaction, or use our alternative payment methods like USSD, bank transfer, or Paystack/Flutterwave wallets.'
    },
    {
      id: 4,
      question: 'What Nigerian banks are supported?',
      answer: 'We support all major Nigerian banks including GTBank, Zenith Bank, Access Bank, First Bank, UBA, Fidelity Bank, Sterling Bank, Union Bank, and more. You can pay via card, bank transfer, or USSD codes. All payments are processed securely through Paystack and Flutterwave.'
    },
    {
      id: 5,
      question: 'Can I pay using USSD or bank transfer?',
      answer: 'Yes! We support USSD payments for GTBank (*737#), Zenith Bank (*966#), Access Bank (*901#), and other major banks. Bank transfers are also available - select "Bank Transfer" at checkout and follow the instructions. Payments are verified automatically within minutes.'
    },
    {
      id: 6,
      question: 'What ID is required for domestic flights?',
      answer: 'For domestic flights within Nigeria, you need a valid government-issued ID such as your National ID Card (NIN), International Passport, Driver\'s License, or Voter\'s Card. The name on your ID must match the name on your booking. Children under 18 may use their birth certificate.'
    },
    {
      id: 7,
      question: 'Why didn\'t I receive my e-ticket email?',
      answer: 'Check your spam/junk folder first. If you still don\'t see it, verify your email address in your profile settings. You can also download your ticket directly from your dashboard under "My Trips". If the issue persists, contact our support team and we\'ll resend it immediately.'
    }
  ];

  const toggleFAQ = (faqId) => {
    setOpenFAQ(openFAQ === faqId ? null : faqId);
  };

  return (
    <div className="support-page">
      <Header />
      
      {/* Hero Section */}
      <section className="support-hero-section">
        <div className="page-container">
          <div className="support-hero-content">
            <h1 className="support-hero-title">How can we help you today?</h1>
            <p className="support-hero-subtitle">
              Quick answers, real agents, and smooth support.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq-section" className="faq-section">
        <div className="page-container">
          <div className="faq-header">
            <h2 className="faq-section-title">Frequently Asked Questions</h2>
            <p className="faq-section-subtitle">
              Quick answers to common questions from Nigerian travelers.
            </p>
          </div>

          <div className="faq-list">
            {faqs.map((faq) => (
              <div key={faq.id} className="faq-item">
                <button
                  className={`faq-question ${openFAQ === faq.id ? 'open' : ''}`}
                  onClick={() => toggleFAQ(faq.id)}
                >
                  <span className="faq-question-text">{faq.question}</span>
                  <span className="faq-toggle-icon">
                    {openFAQ === faq.id ? '−' : '+'}
                  </span>
                </button>
                {openFAQ === faq.id && (
                  <div className="faq-answer">
                    <p className="faq-answer-text">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-support-section">
        <div className="page-container">
          <div className="contact-support-card">
            <h2 className="contact-support-title">Contact Us</h2>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <div className="contact-details">
                  <h3 className="contact-label">Email</h3>
                  <a href="mailto:support@symbolfly.com" className="contact-value">
                    support@symbolfly.com
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <div className="contact-details">
                  <h3 className="contact-label">Phone</h3>
                  <a href="tel:+2348012345678" className="contact-value">
                    +234 801 234 5678
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SupportPage;








